import { createFileRoute } from '@tanstack/react-router'
import { documentActionSearchSchema } from '../../../../features/sales/document-action'
import { ReceiptDetailPage } from '../../../../features/sales/receipt-pages'

export const Route = createFileRoute('/_app/receipts/$receiptId/')({
  validateSearch: documentActionSearchSchema,
  component: ReceiptDetailPage,
})
